/* ============================================================
   Режим витрины сайта.

   'fed'  — НОВЫЙ дизайн «Федерация киберспорта СКО» (src/fed/)
   'fifa' — турнир FIFA OPEN · СКО (страницы из src/fifa/)
   'cs'   — турнир CS2 OPEN · СКО (старые страницы из src/pages/)

   Чтобы вернуть старый интерфейс — поменяй значение на 'fifa'
   или 'cs'. Весь старый код сохранён и продолжает работать.
   ============================================================ */
export const SITE_MODE = 'fed';
